export interface ProductDeclaration {
  customerNumber: string;
  customerName: string;
  orderNumber: string;
  siteNumber: string;
  siteName: string;
  batches: Batch[];
}

export enum ProductDeclarationComponentGroup {
  analytical = 'analytical',
  vitamin = 'vitamin',
  mikronutrientPart1 = 'mikronutrientPart1',
  mikronutrientPart3 = 'mikronutrientPart3',
  pigment = 'pigment',
}

interface ProductComponent {
  componentGroup: ProductDeclarationComponentGroup;
  componentName: string;
  target: number;
  unit: string;
  sortingOrder: number;
  seq: number;
  componentId: number;
}

export interface Batch {
  lineNumber: string;
  itemNumber: string;
  itemName: string;
  itemDescription: string;
  batchNumber: string;
  deliveredQuantity: number;
  invoicedQuantity: number;
  dispatchDate: string;
  designation: string;
  instruction: string;
  labelText: string;
  produced: string;
  bestbefore: string;
  ingredients: string;
  producerNo: string;
  producerName: string;
  producerAddress: string;
  ascSiteId: string | null;
  productComponents: ProductComponent[];
}
